export default "__VITE_ASSET__c148e37a__"